import { DOCUMENT } from '@angular/common';
import { APP_ID, CSP_NONCE, Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ɵSharedStylesHost } from '@angular/platform-browser';

@Injectable()
export class CustomStylesHostService extends ɵSharedStylesHost {
  private readonly REM_BASE = 10;
  private transformStyleCache = new Map<string, string>();

  constructor() {
    const doc = inject<Document>(DOCUMENT);
    const appId = inject(APP_ID);
    const nonce = inject(CSP_NONCE, { optional: true });
    const platformId = inject(PLATFORM_ID) ?? {};

    super(doc, appId, nonce, platformId);
    this['hosts'].clear();
  }

  public addStyles(styles: string[], urls: string[]): void {
    const transformedStyles = styles.map(style => {
      const cachedStyle = this.transformStyleCache.get(style);
      if (cachedStyle) {
        return cachedStyle;
      }

      const transformedStyle = this.remToPX(style);
      this.transformStyleCache.set(style, transformedStyle);
      return transformedStyle;
    });
    super.addStyles(transformedStyles, urls);
  }

  public removeStyles(styles: string[], urls: string[]): void {
    const transformedStyles = styles.map(style => this.transformStyleCache.get(style) ?? style);
    super.removeStyles(transformedStyles, urls);
  }

  private remToPX(style: string): string {
    return style.replace(
      /(((\d+)|(\.\d+)|(\d+\.\d+))rem)/g,
      match => `${parseFloat(match) * this.REM_BASE}px`,
    );
  }
}
